<div class="p-grid">
  <div class="p-col-12">
    <div class="p-grid grid-fluid">
      <div class="p-col"></div>
      <div class="p-col-12 p-md-2" *ngIf="hasDiaryFormCreate">
        <button
          pButton
          (click)="openForm()"
          icon="pi pi-plus"
          type="button"
          label="{{ 'general.add' | translate }}"
        ></button>
      </div>
    </div>
  </div>
  <div class="p-col-12">
    <div class="p-grid">
      <div class="p-ml-5" *ngIf="confForms.length === 0">
        <h4>{{ 'general.noInfo' | translate }}</h4>
      </div>
      <div *ngFor="let data of confForms" class="p-col-12 p-md-6 p-lg-4">
        <app-tpcard
          [tpCardData]="buildTPCardData(data)"
          (edit)="openForm($event)"
          (delete)="onDelete($event)"
          (customAction)="openFormInReadMode($event)"
        >
        </app-tpcard>
      </div>
    </div>
  </div>
</div>
